export const SITE_NAME = "Evalion Inspector Portal";
const SERVER_ENV_NAMES = {
  PROD: "prod",
  PRODUCTION: "production",
  STAGING: "staging",
  LOCAL: "local",
  DEV: "dev",
} as const;

type ServerEnv = (typeof SERVER_ENV_NAMES)[keyof typeof SERVER_ENV_NAMES];

const rawEnv =
  (import.meta.env.VITE_SERVER_ENV as ServerEnv) || SERVER_ENV_NAMES.LOCAL;

const normalizedEnv =
  rawEnv === SERVER_ENV_NAMES.PRODUCTION ? SERVER_ENV_NAMES.PROD : rawEnv;

const featureEnabled = import.meta.env.VITE_ENABLE_VIEWINGS_DISPATCH === "true";
const isLocalOrDev =
  normalizedEnv === SERVER_ENV_NAMES.LOCAL ||
  normalizedEnv === SERVER_ENV_NAMES.DEV;

export const APP_CONFIG = {
  SERVER_BASE_URL:
    import.meta.env.VITE_API_URL ||
    import.meta.env.VITE_SERVER_BASE_URL ||
    "http://127.0.0.1:4000/api",
} as const;

export const APP_ROUTES = {
  ROOT: "/",
  AUTH: {
    LOGIN: "/auth/login",
    OTP: "/auth/otp",
  },
  PORTAL: {
    VIEWINGS: "/portal/viewings",
    VACATION: "/portal/vacation",
    HELP: "/portal/help",
  },
} as const;

export const API_ROUTES = {
  INSPECTOR_PORTAL: {
    AUTH: {
      REQUEST_OTP: "/inspector-portal/auth/request-otp",
      VERIFY_OTP: "/inspector-portal/auth/verify-otp",
      SESSION: "/inspector-portal/auth/session",
      LOGOUT: "/inspector-portal/auth/logout",
    },
    ASSIGNMENTS: {
      GET_ALL: "/inspector-portal/assignments",
      GET_DETAIL: (assignmentId: string) =>
        `/inspector-portal/assignments/${assignmentId}`,
      ACCEPT: (assignmentId: string) =>
        `/inspector-portal/assignments/${assignmentId}/accept`,
      DECLINE: (assignmentId: string) =>
        `/inspector-portal/assignments/${assignmentId}/decline`,
      SCHEDULE: (assignmentId: string) =>
        `/inspector-portal/assignments/${assignmentId}/schedule`,
      FILES: (assignmentId: string) =>
        `/inspector-portal/assignments/${assignmentId}/files`,
      FILE: (assignmentId: string, fileId: number) =>
        `/inspector-portal/assignments/${assignmentId}/files/${fileId}`,
      DOWNLOAD_FILE: (assignmentId: string, fileId: number) =>
        `/inspector-portal/assignments/${assignmentId}/files/${fileId}/download`,
    },
  },
} as const;

export const VIEWINGS_DISPATCH_GUARD = {
  serverEnv: normalizedEnv,
  enabled: isLocalOrDev && featureEnabled,
  hard404: !isLocalOrDev,
} as const;
